<div class="mx-auto d-flex align-items-center justify-content-center my-7">
  <div class="submit-success text-center">
    <img [alt]="'leadForm.success.formSubmitted' | cxTranslate"
         class="mb-5 success-icon"
         src="assets/images/product/success-message-icon.svg">
    <div *ngIf="!externalUrl">
      <h2 class="mb-4 ds-heading--l text-center">
        {{ 'leadForm.success.formSubmitted' | cxTranslate}}
      </h2>
      <p *ngIf="product?.vendor?.name" class="text-center color-grey-2 mx-4">
        {{product.vendor.name}} {{ 'leadForm.success.nextAction' | cxTranslate}}
      </p>
    </div>

    <div *ngIf="!!externalUrl">
      <h2 class="mb-4 ds-heading--l text-center">
        {{ 'leadForm.success.freeTrialIsReady' | cxTranslate}}
      </h2>
      <p class="text-center ds-color--grey-1 mx-4 mb-4">
        {{ 'leadForm.success.getTrialNextAction' | cxTranslate}}
      </p>
      <a [href]="externalUrl"
         class="btn btn-primary"
         rel="noopener noreferrer"
         target="_blank"
         type="button">
        {{ 'leadForm.success.getTrial' | cxTranslate}}
      </a>
    </div>
  </div>
</div>
